// Third-party Library
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

// Constants
import { TEMPLATE } from "../../../v3/constants"

// Components
import GoogleMapPage from "./components/GoogleMaps"
import Info from "./components/Info"

// Services
import { wsContainer } from "../../../v3/services/websocket"
import { RoundUp, TIME } from "../../../v3/services/util"

// Actions
import {
    v3_vehicles,
    v3_drivers,
    v3_vehicleReports
} from '../../../v3/services/redux/actions'

// styles
import style from './index.module.css'
import { FORMATTER_SUMMARY } from "../../../v3/constants/template/report/formatter"

const TabletView = ({
    plate
}) => {

    const dispatch = useDispatch()

    const uid = useSelector(state => state.containers.main.user.uid)
    const vehicles = useSelector(state => state.containers.v3.vehicles)
    const drivers = useSelector(state => state.containers.v3.drivers)
    const summary = useSelector(state => state.containers.v3.vehicleReportDailySummaries)

    // data
    // const testVID = 'vhc#1748398014641-NICQCjKvS_ML' // RFID Test
    // const testVID = 'vhc#1723618991672-QDnbE9IP7Zf-' // ANG3241

    const [testVID, setTestVID] = useState(null)

    const thisVehicle = {
        ...vehicles.stateByID[testVID], 
        ...vehicles.staticsByID[testVID],
    };
    const thisVehicleDerivative = vehicles.derivativeStateByID[testVID]
    const thisVehicleFuelProfile = vehicles.fuelProfileByID[testVID]
    const thisDriver = { ...drivers.byID[thisVehicle?.drvid] }

    const sumData = (FORMATTER_SUMMARY({ vids: [testVID], vehicleReportDailySummaries: summary }))?.[0]

    const totalFuel = RoundUp(sumData[`FP_0_summary`].fuel_consumption.total, 3)
    const totalMileage = RoundUp(sumData['plat_daily_mileage'], 2)


    useEffect(() => {
        if(uid && testVID) {
            dispatch(v3_vehicles.batch_get_vehicles_request([testVID], uid))
            if(thisVehicle?.drvid) {
                v3_drivers.get_driver_session_request(thisVehicle?.drvid, ({ sessionStartAt }) => {
                    dispatch(v3_vehicleReports.get_vehicle_report_summary_by_timeframe_request(
                        testVID,
                        sessionStartAt,
                        TIME.getCurTime()
                    ))
                })
            }
        }
    }, [uid, testVID])

    useEffect(() => {
        if(thisVehicle.drvid) {
            dispatch(v3_drivers.batch_get_drivers_request([thisVehicle.drvid], uid))
        }
    }, [thisVehicle.drvid])

    useEffect(() => {
        dispatch(v3_vehicles.get_vehicle_state_by_plate_request(plate, null, ({vid}) => setTestVID(vid)))
    }, [])

        // Websocket
        useEffect(() => {

            // dispatch(v3_vehicles.get_vehicle_state_by_plate_request(plate, ({vid}) => setTestVID(vid)))
    
            wsContainer(
                (err, data) => {
    
                    if(!err) {
                        const {
                            id: refID,
                            mode,
                            item
                        } = data
    
                        switch(mode) {
                            case TEMPLATE.PACKAGE.WS_PROCESS_PACKAGE.VHC: {
                                const vid = refID
            
                                vid && dispatch(v3_vehicles.update_vehicle_info_thru_ws_request(vid, item))
    
                                break;
                            }
                            default: {
                                break;
                            }
                        }
                    }
                    
                },
                () => {
                    // resubscribe
                }
            )
    
    
        })

    return (
        <div className={style['container']}>
            <GoogleMapPage vid={testVID} location={thisVehicle.location} />
            <Info 
                thisVehicle={thisVehicle} 
                thisVehicleDerivative={thisVehicleDerivative}
                thisVehicleFuelProfile={thisVehicleFuelProfile}
                thisDriver={thisDriver}
                totalFuel={totalFuel}
                totalMileage={totalMileage}
            />
        </div>
    )
}

export default React.memo(TabletView)